import {createContext} from "react";

export const ListContext = createContext({
    loading: false,
    setLoading: () => {},

    listItems: [],
    setListItems: () => {},

    selectedItem: null,
    setSelectedItem: () => {},

    notFilteredListItems: [],
    setNotFilteredListItems: () => {},

    createBelow: {},
    showCreateBelow: () => {},
    hideCreateBelow: () => {},
    openCreateDialogViaCreateBelow: () => {},

    isCreateDialogOpen: false,
    openCreateDialog: (item = null) => {},
    closeCreateDialog: () => {},

    isDeleteDialogOpen: false,
    openDeleteDialog:() => {},
    closeDeleteDialog:() => {},

    showErrorNotification: () => {},

    moveListItem: () => {},
})
